import { msg } from "@lingui/core/macro";
import { usePatients } from "@/api/Patients";
import {
  getPatientFullName,
  patientStatusSchema,
} from "@medoma/models/patients";
import { PatientsTableContainer } from "./PatientsTableContainer";
import { useMemo } from "react";
import { filterByNameTerms } from "@medoma/components/SearchField/searchUtils";
import { usePatientNameFilter } from "../PatientsContext";

export const AllPatients = () => {
  const { value: filter } = usePatientNameFilter();
  const {
    data: patients,
    isPending,
    isError,
    error,
  } = usePatients({
    statuses: [
      patientStatusSchema.enum.prospect,
      patientStatusSchema.enum.admitted,
      patientStatusSchema.enum.declined,
      patientStatusSchema.enum.discharged,
    ],
  });

  const filteredPatients = useMemo(() => {
    if (!filter || !patients) {
      return patients;
    }

    return patients.filter((patient) =>
      filterByNameTerms(getPatientFullName(patient.name), filter),
    );
  }, [patients, filter]);

  const noResultsMessage =
    filteredPatients && patients && filteredPatients.length < patients.length
      ? msg`Det finns inga patienter som matchar sökningen`
      : msg`Det finns inga patienter`;

  return (
    <PatientsTableContainer
      patients={filteredPatients}
      isPending={isPending}
      isError={isError}
      error={error}
      additionalColumns={["admittedAt", "dischargedAt"]}
      showNotifications={true}
      showPatientStatus={false}
      showPatientSignInStatus={false}
      showPrimaryResponsible={true}
      showPlaceOfAssessment={false}
      showPostDischargeProcessed={false}
      loadingMessage={msg`Hämtar patienter`}
      errorMessage={msg`Kunde inte hämta patienter`}
      noResultsMessage={noResultsMessage}
    />
  );
};
